import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../../helpers/authContext";
import { useNavigate, useLocation } from "react-router-dom";

import { Loading } from 'daymap-library';


const VisitorContext = createContext({});

export function useVisitor() {
    return useContext(VisitorContext);
}

export function VisitorProvider({children}) {
    const [visitorSettings, setVisitorSettings] = useState({});
    const {lmsFetch} = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.pathname.endsWith('visitors') && (location.pathname.endsWith("/in") || location.pathname.endsWith("/out")))
        {
            navigate("/visitors");
        } 
        loadSettings();
    }, []);

    const loadSettings = async () => {
        const [getSettings] = lmsFetch('/lms/api/checkin/visitors/settings');
        const response = await getSettings();

        console.log('visitor settings', response.data)

        setVisitorSettings(response.data);
    }

    const value = { visitorSettings };

    return (
        <VisitorContext.Provider value={value}>
            {visitorSettings ? children : <Loading text="Loading Visitor Configuration" />}
        </VisitorContext.Provider>
    )
}